import { render, staticRenderFns } from "./ModificaReclamo.vue?vue&type=template&id=20050448"
import script from "./ModificaReclamo.vue?vue&type=script&lang=js"
export * from "./ModificaReclamo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports